import { render } from "./CitadelOne.vue?vue&type=template&id=94ce4986&scoped=true"
import script from "./CitadelOne.vue?vue&type=script&lang=js"
export * from "./CitadelOne.vue?vue&type=script&lang=js"

import "./CitadelOne.vue?vue&type=style&index=0&id=94ce4986&lang=scss&scoped=true"

import exportComponent from "/home/cosmic/citadel-website/citadel-landing-dao-version-citadelone/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94ce4986"]])

export default __exports__